import { render, staticRenderFns } from "./userDashboardNutritionForm.vue?vue&type=template&id=465a1d48"
import script from "./userDashboardNutritionForm.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports